import { Card, CardContent, Typography } from '@material-ui/core';
import React from 'react';
import useStyles from "./styles";

const PageNotFound = () => {
    const classes = useStyles();

    return (
        <Card className={classes.card}>
            <CardContent>
                <Typography className={classes.details} variant="h5" color="textSecondary" component="p">404 Error. Page Not found!</Typography>
            </CardContent>
        </Card>
    )
}

export default PageNotFound
